import { performRequest} from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { GET_DAILY_REPORT_INFO,
        GET_DAILY_REFUND_REPORT_INFO,
        GET_PACKAGE_REPORT,
        GET_YEARLY_SALES_REPORT,
        GET_MONTHLY_SALES_REPORT,
        GET_BALANCE_REPORT,
        GET_DEPOSIT_REPORT,
        GET_MONTHLY_BALANCE_REPORT,
        GET_MONTHLY_TRANS_REPORT,
        GET_REFUND_REPORT,
        GET_CONFIRMATION_REPORT,
        GET_REWARDS_REFERRAL,
        GET_REWARDS_REPORT,
        GET_REWARDS_DETAILS,
        GET_EVENTS_MONTHLY_REPORT,
        GET_TOP_LEVEL_AGENT,
        GET_ROOM_CAPACITY_URL,
        GET_BALANCE_REPORT_URL,
        GET_ROOM_SUMMERY_REPORT_URL,
        GET_OTHERS_REVENUE_REPORT,
        GET_POS_REVENUE_REPORT,
        GET_PAYMENT_COLLECTION_REPORT,
        GET_TAX_CHARGES_REPORT,
        GET_TAX_CHARGES_REPORT_CHECKOUT,
        GET_DEBTOR_REPORT_URL,
        GET_ANALYSIS_REPORT_URL,
        GET_FERRY_ADDON_REPORT_URL
           } = URLS;
    return {
        getDailyReport: (body={}, method='get',date,toSelectedDate) =>
         performRequest( method ? method:'get', GET_DAILY_REPORT_INFO.replace(":fromdate", date).replace(":todate", toSelectedDate), body ),
        getDailyRefundReport: (body={}, method='get',date) =>
         performRequest( method ? method:'get', GET_DAILY_REFUND_REPORT_INFO.replace(":date", date), body ),
        getPackageReport: (body={}, method='get',month,year) =>
         performRequest( method ? method:'get', GET_PACKAGE_REPORT.replace(":month", month).replace(":year", year), body ),
        getYearlySalesReport: (body={}, method='get',year, query) =>
         performRequest( method ? method:'get', `${GET_YEARLY_SALES_REPORT.replace(":year", year)}?type=${query}`, body ),
        getBalanceReport: (body={}, method='get',year,qeury) =>
         performRequest( method ? method:'get', GET_BALANCE_REPORT.replace(":year", year)+qeury, body ),
        getRefundReport: (body={}, method='get',year) =>
         performRequest( method ? method:'get', GET_REFUND_REPORT.replace(":year", year), body ),
        getConfirmationReport: (body={}, method='get',year) =>
         performRequest( method ? method:'get', GET_CONFIRMATION_REPORT.replace(":year", year), body ),
         getMonthlyBalanceReport: (body={}, method='get',month,year,qeury) =>
         performRequest( method ? method:'get', GET_MONTHLY_BALANCE_REPORT.replace(":month", month).replace(":year", year)+qeury, body ),
        getMonthlyTransReport: (body={}, method='get',month,year) =>
         performRequest( method ? method:'get', GET_MONTHLY_TRANS_REPORT.replace(":month", month).replace(":year", year), body ),
         getMonthlySalesReport: (body={}, method='get',year,month, query) =>
         performRequest( method ? method:'get', `${GET_MONTHLY_SALES_REPORT.replace(":year", year).replace(":month", month)}?type=${query}`, body ),
        gerDepositReport: (body={}, method='get',year) =>
         performRequest( method ? method:'get', GET_DEPOSIT_REPORT.replace(":year", year), body ),
        getRewardReferal: (body={}, method='get',month,year,qeury) =>
         performRequest( method ? method:'get', GET_REWARDS_REFERRAL.replace(":monthData", month).replace(":yearData", year)+qeury, body ),
        getRewardReport: (body={}, method='get') =>
         performRequest( method ? method:'get', GET_REWARDS_REPORT, body ),
        getRewardDetails: (body={}, method='get') =>
         performRequest( method ? method:'get', GET_REWARDS_DETAILS.replace(':_id', body._id), body ),
        getEventsMonthlyReport: (body={}, method='get',year,month) =>
         performRequest( method ? method:'get', GET_EVENTS_MONTHLY_REPORT.replace(":year", year).replace(":month", month), body ),
        getTopLevelAgent: (body={}, method='get',year,month,limit,code) =>
         performRequest( method ? method:'get', GET_TOP_LEVEL_AGENT.replace(":yearData", year).replace(":monthData", month).replace(":limitData", limit).replace(":codeData", code), body ),
        getRoomTypesReport: (body={}, method='get') =>
            performRequest(method ? method:'get', GET_ROOM_CAPACITY_URL, body),
        checkoutBalanceReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_BALANCE_REPORT_URL}/${body.from}/${body.to}`, {}),
        roomSummeryReport: (body={}, method='get') =>
            performRequest(
              method ? method : 'get',
              `${GET_ROOM_SUMMERY_REPORT_URL}/${body.from}/${body.to}`,
              { company: body.company || 'reservation' }
            ),
        othersRevenueReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_OTHERS_REVENUE_REPORT}/${body.from}/${body.to}`, { company: body.company || 'reservation' }),
        posRevenueReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_POS_REVENUE_REPORT}/${body.from}/${body.to}`, { company: body.company || 'resort' }),
        paymentCollectionReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_PAYMENT_COLLECTION_REPORT}/${body.from}/${body.to}`, { company: body.company || 'reservation' }),
        taxChargesReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_TAX_CHARGES_REPORT}/${body.from}/${body.to}`, { company: body.company || 'reservation' }),
        taxChargesReportCheckOut: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_TAX_CHARGES_REPORT_CHECKOUT}/${body.from}/${body.to}`, { company: body.company || 'reservation' }),
        getDebtorReport: (body={}, method='get', startDate, endDate) =>
            performRequest( method ? method:'get', GET_DEBTOR_REPORT_URL.replace(":startDate", startDate).replace(":endDate", endDate), body ),
        getAnalysisReport: (body={}, method='get') =>
            performRequest(method ? method:'get', `${GET_ANALYSIS_REPORT_URL}/${body.from}/${body.to}`, { dateType: body.dateType || 'reservation' }),
        getFerryAddonReport: (body={}, method='get', date) =>
            performRequest( method ? method:'get', GET_FERRY_ADDON_REPORT_URL.replace(":date", date), body ),
    }
}